/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-16 20:41:05
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-09-27 13:41:20
 */

import { objAny } from "../common/common-interface";
export const routerFor = (list: object[], key?: string): object[] => {
  const arr: object[] = [];
  let itemIndex = 0;
  list.map((item: objAny) => {
    let isTrue = false;
    if (item.privilegeVoList) {
      item.privilegeVoList.map((vo: objAny) => {
        if (vo.privilegeCode == "100501" && vo.checked) {
          isTrue = true;
        }
      });
    }
    if (!item.privilegeVoList) {
      isTrue = true;
    }
    if (key) {
      item.menuIndex = key + "-" + itemIndex;
    } else {
      item.menuIndex = itemIndex + "";
    }
    if (item.children) {
      item.children = routerFor(item.children, item.menuIndex);
    }

    if (isTrue) {
      itemIndex = itemIndex + 1;
      arr.push(item);
    }
  });
  return arr;
};

export const routerForUrl = (list: object[]): any => {
  let itemData: any = null;
  let isTrue = false;
  list.map((item: objAny) => {
    if (item.privilegeVoList) {
      item.privilegeVoList.map((vo: objAny) => {
        if (vo.privilegeCode == "100501" && vo.checked) {
          if (
            (!itemData && !item.children) ||
            (!itemData && item.children.length == 0)
          ) {
            itemData = item;
          } else {
            isTrue = true;
          }
        }
      });
    }
    if (!itemData && isTrue) {
      itemData = routerForUrl(item.children);
    }
  });
  return itemData;
};
